import React, { useState } from "react";
import styles from "./CustomizedField.module.css";
import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import deleteImage from "./Images/delete.svg";
import CancelBtn from "../../../../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../../../../components/Buttons/SaveBtn";
import EditIconBtn from "../../../../../../../../components/Buttons/EditIconBtn";
import DeleteBtn from "../../../../../../../../components/Buttons/DeleteBtn";
import DeletePopup from "../../../../../../../../components/CommonPopups/DeletePopup";

function CustomizedEmailField(props: any) {
  const {
    onFieldChange,
    field,
    onDelete,
    leadsFromResponseChecked,
    edit = false,
    deleteAction = false,
    mandatory = false,
    isNameUniqueCheck,
  } = props;
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [question, setQuestion] = useState<string>("");
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
  };

  const handleSaveClick = (e: any) => {
    onFieldChange({
      ...field,
      fieldName: question,
    });
    setIsEditing(false);
  };

  const handleQuestionChange = (e: any) => {
    setQuestion(e.target.value);
    onFieldChange({
      ...field,
      fieldName: e.target.value,
    });
  };

  const handleDeleteConfirmed = () => {
    setShowDeletePopup(false);
    onDelete(field);
  };

  const handleDeleteCancelled = () => {
    setShowDeletePopup(false);
  };

  const handleMandatoryChange = (e: any) => {
    const isMandatory = e.target.checked;
    onFieldChange({
      ...field,
      required: isMandatory,
    });
  };

  React.useEffect(() => {
    setQuestion(field?.fieldName);
  }, [field]);

  return (
    <div className={styles.customizedFieldWrapper}>
      <div className={styles.customizedFieldTop}>
        <div className={styles.label}>
          {field.fieldName}
          {field.required === true && <span style={{ color: "red" }}>*</span>}
        </div>
        {!isEditing && (
          <div className={styles.customizedFieldTopRight}>
            {edit && <EditIconBtn onClick={handleEditClick} />}
            {deleteAction && (
              <DeleteBtn
                icon={deleteImage}
                onClick={() => setShowDeletePopup(!showDeletePopup)}
              />
            )}
            {showDeletePopup && (
              <DeletePopup
                open={showDeletePopup}
                onClose={handleDeleteCancelled}
                noBtnClick={handleDeleteCancelled}
                yesBtnClick={handleDeleteConfirmed}
                title={"Are you sure you want to delete this question?"}
              />
            )}
          </div>
        )}
      </div>
      <TextField
        value={isEditing ? question : ""}
        onChange={handleQuestionChange}
        fullWidth
        variant="outlined"
        disabled={!isEditing}
        size="small"
        inputProps={{
          style: {
            padding: "8px 12px",
            backgroundColor: isEditing ? "#FFFFFF" : "#FAFAFA",
            borderRadius: "4px",
          },
        }}
        error={isEditing && !isNameUniqueCheck(question, field?.index)}
        helperText={
          isEditing && !isNameUniqueCheck(question, field?.index)
            ? "Field label already exist"
            : ""
        }
      />
      {mandatory && (
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              onChange={handleMandatoryChange}
              checked={field?.required}
              sx={{
                strokeWidth: 1,
                color: "#D0D5DD",
              }}
            />
          }
          label="Mandatory"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "13px",
              color: "#667085",
              lineHeight: "20px",
            },
          }}
        />
      )}

      {isEditing && (
        <div className={styles.btnsWrap}>
          <CancelBtn onClick={handleCancelClick} />
          <SaveBtn
            onClick={handleSaveClick}
            disabled={
              !question.trim() || !isNameUniqueCheck(question, field?.index)
            }
          />
        </div>
      )}
    </div>
  );
}
export default CustomizedEmailField;
